export default "__VITE_ASSET__CqA2XjJj__"